import React, { useEffect, useState } from 'react';

import { getTodayISO, toISODate } from '@libs/NwMoment';

import useLocalStorageState from '@hooks/Utils/UseLocalStorageState';

import { Loading } from '@components/Gui/Loading';
import ContactScheduleCard from '@components/Schedule/ContactScheduleCard';
import { getCalendarStyle, getCurrentMonthRangeDates, getCurrentWeekRange } from '@components/Schedule/ScheduleUtils';

//TODO: GET LAST DATE SAVED IN LOCAL STORAGE AND PASS TO THE AGENDACONTAINER AS STARTDATE?

const ModelDetailsCalendar = ({ isMobileDrawer, idmodel, previewMode, stretchToParent = false }) => {
    // calendarStyle, onChangeCalendarStyle

    let defaultSchedulePeriod = { start: getTodayISO(), end: getTodayISO() };

    // if (calendarStyle === 'week') {
    //     defaultSchedulePeriod = { start: getCurrentWeekRange().start, end: getCurrentWeekRange().end };
    // }
    // if (calendarStyle === 'month') {
    //     defaultSchedulePeriod = { start: getCurrentMonthRangeDates().start, end: getCurrentMonthRangeDates().end };
    // }

    const [scheduleStartRange, setScheduleStartRange] = useState(defaultSchedulePeriod.start);
    const [scheduleEndRange, setScheduleEndRange] = useState(defaultSchedulePeriod.end);
    const [scheduleRange, setScheduleRange] = useState(null);
    // week|month|agenda based on the scheduleRange timespan

    const [filters, setFilters] = useLocalStorageState('contact-schedule-filters', {
        filterMine: 'all',
        filterAcknowledgement: 'all',
        hideCancelled: false,
        hideBilling: false,
    });

    useEffect(() => {
        if (scheduleStartRange && scheduleEndRange) {
            const dateObject = { start: new Date(scheduleStartRange), end: new Date(scheduleEndRange) };

            setScheduleRange(dateObject);
            // onChangeCalendarStyle(getCalendarStyle(dateObject));
        }
    }, [scheduleStartRange, scheduleEndRange]);

    const handleScheduleRangeChange = (start, end) => {
        setScheduleStartRange(toISODate(start));
        setScheduleEndRange(toISODate(end));
    };

    return scheduleRange ? (
        <ContactScheduleCard
            type="model"
            contactId={idmodel}
            filters={filters}
            setFilters={setFilters}
            scheduleRange={scheduleRange}
            onScheduleRangeChange={handleScheduleRangeChange}
            // calendarStyle={calendarStyle}
            calendarStyle="agenda"
            previewMode={previewMode}
            isMobileDrawer={isMobileDrawer}
            stretchToParent={stretchToParent}
        />
    ) : (
        <Loading />
    );
};

export default ModelDetailsCalendar;
